export default class Timer {
  constructor({ interval, timeout, callback = () => null }) {
    if (!interval && !timeout)
      throw new Error("Timer must be only with interval or timeout");

    this.interval = interval;
    this.timeout = timeout;
    this.callback = callback;

    this.timerId = null;
  }

  start = () => {
    this.stop();
    if (this.interval) {
      this.timerId = setInterval(() => this.callback(), this.interval);
    } else {
      this.timerId = setTimeout(() => this.callback(), this.timeout);
    }
  };

  stop = () => {
    if (this.interval) {
      clearInterval(this.timerId);
    } else {
      clearTimeout(this.timerId);
    }
  };

  dispose = () => {
    this.stop();
    this.timerId = null;
    this.interval = null;
    this.timeout = null;
    this.callback = null;
  };
}
